import * as React from 'react'
import withHydrationOnDemand from 'react-hydration-on-demand'

import { i18n, Routes } from '@thg-commerce/enterprise-core'
import { withBasketType } from '@thg-commerce/gravity-patterns/Header/Header'
import { addToDataLayer } from '@thg-commerce/enterprise-metrics/src/data_layer'

import { useBasket } from '../Basket/hooks/useBasketId'

const MiniBasketRenderer = ({ Component }) => {
  const { basket } = useBasket()

  const earnableLoyaltyPoints = basket?.earnableLoyaltyPoints

  const miniBasketI18nText = {
    basketSummarySingular: i18n('header.basket.summary.singular.text'),
    basketSummary: i18n('header.basket.summary.text'),
    basketView: i18n('header.basket.viewbasket.text'),
    basketEmpty: i18n('header.basket.noitems.text'),
    continueShopping: i18n('header.basket.button.continueshopping.text'),
    itemListAriaLabel: i18n('header.basket.items.arialabel'),
    quantityText: i18n('header.basket.qty.text'),
    freePriceText: i18n('product.freeprice.text'),
    loyaltyText: i18n('basket.loyalty.text', String(earnableLoyaltyPoints)),
  }

  const basketItems = basket?.items?.map((item) => {
    return {
      name: item?.product?.title || '',
      sku: item?.product?.product?.sku,
      quantity: item?.quantity || 0,
      price: {
        amount: item.standardPricePerUnit?.amount || '0.00',
        price: item.standardPricePerUnit?.displayValue || '0.00',
      },
      imageUrl: item?.product?.product?.images?.[0]?.largeProduct,
      productUrl: item?.product?.product?.url,
      freeGift: item?.freeGift,
    }
  })

  const miniBasketLinks = {
    viewBasket: Routes.Basket,
  }

  const basketOverview = {
    earnableLoyaltyPoints,
    items: basketItems,
    totalPrice: basket?.chargePrice?.displayValue || '0.00',
    totalQuantity: basket?.totalQuantity || 0,
  }

  React.useEffect(() => {
    if (basket) {
      addToDataLayer({
        key: 'basketTotal',
        value: basket.chargePrice?.amount || '0.00',
      })
      addToDataLayer({
        key: 'basketProducts',
        value: basketOverview.items?.map((item) => {
          return {
            id: item.sku?.toString(),
            sku: item.sku?.toString(),
            name: item.name,
            price: item.price.amount.toString(),
            quantity: item.quantity.toString(),
          }
        }),
      })
    }
  }, [basket])

  return (
    <Component
      basket={{
        basketData: basketOverview,
        links: miniBasketLinks,
        i18nText: miniBasketI18nText,
      }}
    />
  )
}

const MiniBasketRendererComponent = withHydrationOnDemand({
  on: [['idle']],
})(MiniBasketRenderer)

export const withBasket: withBasketType = (props) => {
  return () => <MiniBasketRendererComponent {...props} />
}
